import React, { Component } from "react";
import { Badge, ListGroup, ListGroupItem } from "reactstrap";
import Icon from "../components/Icon";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
} from "../global/browserFunctions";

class CustomerSidebar extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.links = [
      {
        icon: "paper-bag-1",
        link: "/orders",
        active: false,
        title: "Orders",
      },
      {
        icon: "real-estate-1",
        link: "/address",
        active: false,
        title: "My Addresses",
      }
    ];
    this.state = {
      links: this.links,
    };
    this.signOut = this.signOut.bind(this);
  }
  signOut(isSignout) {
    if (isSignout) {
      eraseCookie("log");
      eraseCookie("name");
      if (this.props.history) this.props.history.push("/");
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  componentDidMount() {
    var path = window.location.pathname;
    var links = [...this.state.links];
    var index = links.findIndex(
      (x) => x.link == path
    );
    if (index >= 0) {
      links[index].active = true;

      this.setState({ links: links })
    }


  }

  render() {
    return (
      <div className="customer-sidebar card border-0">
        {/* <ListGroup className="customer-nav">
          {this.state.links.map((link, index) => (
            <a href={link.link} key={index}>
              <ListGroupItem
                tag="a"
                className={`${link.active ? "active" : ""
                  } d-flex justify-content-between align-items-center`}
              >
                <span>
                  <Icon icon={link.icon} className="svg-icon-heavy mr-2" />
                  {link.title}
                </span>
              </ListGroupItem>
            </a>
          ))}
          <a href="#" onClick={() => this.signOut(true)}>
            <ListGroupItem
              tag="a"
              className="d-flex justify-content-between align-items-center"
            >
              <span>
                <Icon icon="exit-1" className="svg-icon-heavy mr-2" />
                Log out
              </span>
            </ListGroupItem>
          </a>
        </ListGroup> */}
        <ListGroup className="customer-nav">
          {this.state.links.map((link, index) => (
            <ListGroupItem
              href={link.link}
              key={index}
              tag="a"
              className={`${link.active ? "active" : ""
                } d-flex justify-content-between align-items-center`}
            >
              <span>
                <Icon icon={link.icon} className="svg-icon-heavy mr-2" />
                {link.title}
              </span>
            </ListGroupItem>
          ))}
          <ListGroupItem
            href="#" onClick={() => this.signOut(true)}
            tag="a"
            className="d-flex justify-content-between align-items-center"
          >
            <span>
              <Icon icon="exit-1" className="svg-icon-heavy mr-2" />
              Log out
            </span>
          </ListGroupItem>
        </ListGroup>
      </div>
    );
  }
}

export default CustomerSidebar;
